import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Col,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Progress,
  Row,
  Spinner,
} from "reactstrap";
import * as Yup from "yup";
import { formatDateStringToKorea, formatTimeISOString } from "helpers/format";
import { unique } from "helpers/validate_yup";
import DropdownOption from "components/Common/DropdownOption";
import DatePicker from "react-datepicker";
import {
  getRedeemCodeDetail,
  postRedeemCode,
  putRedeemCode,
} from "store/redeemCode/thunk";
import DropdownStatusNew from "components/Common/DropdownStatusNew";
import {
  COLOR_PAYMENT_METHOD,
  COLOR_STATUS_PAYMENT,
  LIST_LANGUAGE_OPTION,
  LIST_PAYMENT_METHOD_OPTION,
  LIST_REDEEM_STATUS_OPTION,
  LIST_STATUS_PAYMENT_OPTION,
} from "helpers/constans";
import CourseList from "./CourseList";
import { ICourse } from "api/types/_params";
import ModalConfirm from "components/Common/ModalConfirm";
import DropdownAsyncAgency from "components/Common/DropdownAsyncAgency";
import DropdownCurrency from "components/Common/DropdownCurrency";
import TooltipCustom from "components/Common/TooltipCustom";
export interface Props {
  id?: string;
  triggerRefresh?: () => void;
  isShowDetail?: boolean;
  setLinkImage?: any;
  setIsOpen?: any;
  setItemToEdit?: any;
  agencyList?: any;
}

registerLocale("en", en);
registerLocale("ko", ko);

Yup.addMethod(Yup.array, "unique", unique);

const AgencyForm = ({
  id = "",
  triggerRefresh,
  isShowDetail = false,
  setLinkImage,
  setIsOpen,
  setItemToEdit,
  agencyList,
}: Props) => {
  const { t, i18n } = useTranslation();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isFirstProgress, setIsFirstProgress] = useState<boolean>(true);
  const [isOpenConfirm, setIsOpenConfirm] = useState<string>("");
  const [selectedAgency, setSelectedAgency] = useState<any>(null);

  const onCloseConfirmClick = () => {
    setIsOpenConfirm("");
  };

  const handleSubmit = async (values: any) => {
    try {
      setIsLoading((_prev) => true);

      const course_ids = values?.courses?.map((item: any) => item?.id) || null;
      const data = {
        code: values?.code || null,
        validity_option: values?.validity_option || null,
        agency_id: values?.agency_id || null,
        amount: values?.amount || null,
        payment_method: values?.payment_method || null,
        payment_status: values?.payment_status || null,
        origin_price: values?.origin_price || null,
        after_price: values?.after_price || null,
        curency: values?.curency || null,
        valid_from: values?.validity_option
          ? formatTimeISOString(values?.valid_from)
          : null,
        valid_to: values?.validity_option
          ? formatTimeISOString(values?.valid_to)
          : null,
        note: values?.note || null,
        currency: values?.currency || null,
        course_ids,
      };

      const response: any = id
        ? await putRedeemCode(id, data)
        : await postRedeemCode(data);

      if (response?.data) {
        setIsLoading((_prev) => false);
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
        triggerRefresh && triggerRefresh();
      } else {
        setIsLoading((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsLoading((_prev) => false);
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const validationSchema = Yup.object({
    code: Yup.string().when(
      "is_code_manually_created",
      (is_code_manually_created, schema) => {
        if (is_code_manually_created?.[0] === "enter")
          return schema
            .required(`${t("Redeem Code is required")}`)
            .matches(
              /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/,
              t("RedeemCode_error")
            );
        return schema;
      }
    ),

    agency_id: Yup.string().required(`${t("Agency is required")}`),
    // payment_status: Yup.string().required(`${t("Payment Status is required")}`),
    // payment_method: Yup.string().required(`${t("Payment Method is required")}`),
    // origin_price: Yup.string().required(`${t("Origin Price is required")}`),
    // after_price: Yup.string().required(`${t("After Price is required")}`),

    valid_from: Yup.string().when(
      "validity_option",
      (validity_option, schema) => {
        if (!!validity_option?.[0])
          return schema.required(`${t("Valid From is required")}`);
        return schema;
      }
    ),
    valid_to: Yup.string().when(
      "validity_option",
      (validity_option, schema) => {
        if (!!validity_option?.[0])
          return schema.required(`${t("Valid To is required")}`);
        return schema;
      }
    ),
    currency: Yup.string().required(`${t("Currency is required")}`),
    // valid_from: Yup.string().required(`${t("Valid From is required")}`),
    // valid_to: Yup.string().required(`${t("Valid To is required")}`),
    // amount: Yup.string().required(`${t("Agency Payable Amount is required")}`),
    courses: Yup.array()
      .of(
        Yup.object().shape({
          id: Yup.string().required(`${t("Course is required")}`),
        })
      )
      .min(1, `${t("Courses must have at least 1 element")}`),
  });

  const formik = useFormik({
    initialValues: {
      code: "",
      is_code_manually_created: "auto",
      validity_option: false,
      agency_id: "",
      amount: "",
      origin_price: "",
      after_price: "",
      currency: "KRW",
      payment_status: "",
      payment_method: "",
      valid_from: new Date(),
      valid_to: new Date(),
      note: "",
      language: "en",
      status: "",
      created_at: "",
      updated_at: "",
      courses: [
        {
          id: "",
          number_of_courses: null,
          started_at: new Date(),
          expired_at: new Date(new Date().setDate(new Date().getDate() + 120)),
          status: 1,
        },
      ] as ICourse[],
    },
    validationSchema,
    onSubmit: handleSubmit,
  });

  const handleSetValueForm = (valueDefault: any) => {
    const courses = valueDefault?.courses?.map((item: any) => ({
      value: item?.id,
      data: item,
      id: item?.id,
    }));

    formik.setValues({
      code: valueDefault?.code,
      is_code_manually_created: valueDefault?.is_code_manually_created
        ? "enter"
        : "auto",
      validity_option: !!valueDefault?.validity_option,
      agency_id: valueDefault?.agency_id,
      amount: valueDefault?.amount,
      origin_price: valueDefault?.origin_price,
      after_price: valueDefault?.after_price,
      currency: valueDefault?.currency,
      payment_status: valueDefault?.payment_status,
      payment_method: valueDefault?.payment_method,
      valid_from: valueDefault.valid_from
        ? new Date(formatDateStringToKorea(valueDefault.valid_from))
        : new Date(),
      valid_to: valueDefault.valid_to
        ? new Date(formatDateStringToKorea(valueDefault.valid_to))
        : new Date(),
      note: valueDefault?.note,
      language: valueDefault?.courses?.[0]?.lang || "en",
      courses,
      status: valueDefault?.status,
      created_at: formatDateStringToKorea(valueDefault?.created_at),
      updated_at: formatDateStringToKorea(valueDefault?.updated_at),
    });
    let vAgencyOption: any = {
      value: String(valueDefault?.agency?.id),
      label: (
        <div className="d-flex align-items-center gap-2">
          <div>{`${
            valueDefault?.agency?.code ? valueDefault?.agency?.code : ""
          } ${
            valueDefault?.agency?.name ? " - " + valueDefault?.agency?.name : ""
          }`}</div>
        </div>
      ),
      data: valueDefault?.agency,
    };
    setSelectedAgency(vAgencyOption);
  };

  const handleCallDetail = async (idItem: string) => {
    try {
      if (!idItem) {
        return;
      }
      const resDetail: any = await getRedeemCodeDetail(idItem);

      if (resDetail?.data) {
        handleSetValueForm(resDetail?.data);
      }
    } catch (error: any) {
      return error;
    }
  };

  const handleAction = () => {
    formik.setFieldValue("language", isOpenConfirm);
    formik.setFieldValue("courses", []);
    setIsOpenConfirm("");
  };

  const onCloseClick = () => {
    setIsOpen(false);
    setItemToEdit(false);
  };

  useEffect(() => {
    handleCallDetail(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    document.title = `${t("Create Agency")} - ${t(
      "Agency"
    )} | Picaverse Agency Star+`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  useEffect(() => {
    if (Object.keys(formik.errors).length > 0) {
      setIsFirstProgress(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Object.keys(formik.errors).length]);

  return (
    <React.Fragment>
      <Modal isOpen={true} centered={true} scrollable={false} size="xl">
        <ModalHeader toggle={isLoading ? () => {} : onCloseClick}>
          {isShowDetail
            ? t("Redeem Code Detail")
            : id
            ? t("Update Redeem Code")
            : t("Create Redeem Code")}
        </ModalHeader>
        <ModalBody className="py-3 px-4">
          {!isShowDetail && (
            <div className="mb-4">
              <Progress
                value={
                  !isFirstProgress || !!id
                    ? 100 -
                      (100 / 4) * Number(Object.keys(formik.errors).length)
                    : 0
                }
                color="primary"
                className="animated-progress progress-sm"
              />
            </div>
          )}

          <div className="mt-3">
            <>
              {/* {isLoadingDetail && (
                <div
                  style={{
                    position: "absolute",
                    zIndex: 3,
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0,
                    backgroundColor: "rgb(164 164 164 / 36%)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Spinner size="sm" color="primary"></Spinner>
                </div>
              )} */}
              <form onSubmit={formik.handleSubmit}>
                <Row
                  className="modal-custom-scroll"
                  style={{ overflowY: "auto", maxHeight: "68vh" }}
                >
                  <Col lg={6}>
                    <div className="mb-3">
                      <Label htmlFor="code" className="form-label">
                        {t("Redeem Code")}{" "}
                        <span className="text-danger">*</span>
                      </Label>
                      <div
                        className="d-flex gap-4 align-items-center"
                        style={{ height: "39px" }}
                      >
                        <div className="d-flex gap-4 align-items-center flex-nowrap">
                          <div
                            className="d-flex gap-2 align-items-center cursor-pointer flex-nowrap"
                            onClick={() =>
                              !id &&
                              formik.setFieldValue(
                                "is_code_manually_created",
                                "auto"
                              )
                            }
                          >
                            <input
                              type="radio"
                              name="is_code_manually_created"
                              checked={
                                formik?.values?.is_code_manually_created ===
                                "auto"
                              }
                              disabled={!!id}
                              onChange={() =>
                                formik.setFieldValue(
                                  "is_code_manually_created",
                                  "auto"
                                )
                              }
                            />
                            <p className="m-0 text-nowrap">Auto generate</p>
                          </div>
                          <div
                            className="d-flex gap-2 align-items-center cursor-pointer flex-nowrap"
                            onClick={() =>
                              !id &&
                              formik.setFieldValue(
                                "is_code_manually_created",
                                "enter"
                              )
                            }
                          >
                            <input
                              type="radio"
                              name="is_code_manually_created"
                              checked={
                                formik?.values?.is_code_manually_created ===
                                "enter"
                              }
                              disabled={!!id}
                              onChange={() =>
                                formik.setFieldValue(
                                  "is_code_manually_created",
                                  "enter"
                                )
                              }
                            />
                            <p className="m-0 text-nowrap">Enter manually</p>
                          </div>
                        </div>
                        {(formik?.values?.is_code_manually_created ===
                          "enter" ||
                          !!id) && (
                          <div
                            className="d-flex gap-1 w-100"
                            style={{ position: "relative" }}
                          >
                            <Input
                              name="code"
                              type="text"
                              className="form-control"
                              id="code"
                              disabled={!!id}
                              placeholder={t("Enter redeem code")}
                              value={formik?.values?.code?.toUpperCase()}
                              onChange={(event: any) =>
                                formik.setFieldValue(
                                  "code",
                                  event?.target?.value
                                )
                              }
                            />

                            <TooltipCustom
                              title={t("RedeemTooltip")}
                              className="d-inline-block vertical-align-middle ms-1 thumbnail-mt"
                              style={{
                                transform: "translateY(2px)",
                                // position: "absolute",
                                // right: 0,
                                // top: -30,
                                // zIndex: 100,
                              }}
                            >
                              <i
                                className="ri-question-line align-bottom text-secondary"
                                style={{ fontSize: "16px" }}
                              ></i>
                            </TooltipCustom>
                          </div>
                        )}
                      </div>
                      {formik.touched.code && formik.errors.code ? (
                        <div className="text-danger mt-2">
                          {formik.errors.code}
                        </div>
                      ) : null}
                    </div>
                  </Col>

                  {!isShowDetail ? (
                    <React.Fragment>
                      <Col lg={6}>
                        <div className="mb-3">
                          <Label htmlFor="agency_id" className="form-label">
                            {t("Agency")} <span className="text-danger">*</span>
                          </Label>
                          <DropdownAsyncAgency
                            name="agency_id"
                            onChangeSelect={(event: any) => {
                              formik.setFieldValue("agency_id", event?.value);
                              setSelectedAgency(event);
                            }}
                            isDisabled={isShowDetail}
                            isMulti={false}
                            placeholder={`${t("Select Agency")}...`}
                            isShowIconCheck={false}
                            isAllOption={false}
                            listCheckedUsers={selectedAgency}
                          />

                          {formik?.touched?.agency_id &&
                          formik?.errors?.agency_id ? (
                            <div className="text-danger mt-2">
                              {formik?.errors?.agency_id}
                            </div>
                          ) : null}
                        </div>
                      </Col>
                      <Col lg={3}>
                        <div className="mb-3">
                          <Label htmlFor="currency" className="form-label">
                            {t("Currency")}{" "}
                            <span className="text-danger">*</span>
                          </Label>
                          <DropdownCurrency
                            name="currency"
                            placeholder={`${t("Select currency")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={formik?.values?.currency}
                            disabled={isShowDetail}
                            onChangeSelect={(event: any) => {
                              formik.setFieldValue("currency", event?.value);
                            }}
                          />
                          {formik.touched.currency && formik.errors.currency ? (
                            <div className="text-danger mt-2">
                              {formik.errors.currency}
                            </div>
                          ) : null}
                        </div>
                      </Col>

                      <Col lg={3}>
                        <div className="mb-3">
                          <Label htmlFor="amount" className="form-label">
                            {t("Agency Payable Amount")}{" "}
                            {/* <span className="text-danger">*</span> */}
                          </Label>
                          <Input
                            id="amount"
                            name="amount"
                            type="text"
                            className="form-control"
                            placeholder={t("Enter agency payable amount")}
                            value={formik?.values?.amount}
                            disabled={isShowDetail}
                            onChange={(event: any) =>
                              formik.setFieldValue(
                                "amount",
                                event?.target?.value
                              )
                            }
                          />
                          {formik.touched.amount && formik.errors.amount ? (
                            <div className="text-danger mt-2">
                              {formik.errors.amount}
                            </div>
                          ) : null}
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="mb-3">
                          <Label
                            htmlFor="payment_method"
                            className="form-label"
                          >
                            {t("Payment Method")}{" "}
                            {/* <span className="text-danger">*</span> */}
                          </Label>
                          <div className="w-100">
                            <DropdownStatusNew
                              name="payment_method"
                              dataList={LIST_PAYMENT_METHOD_OPTION || []}
                              placeholder={`${t("Select Status")}...`}
                              className="dropdown-status-rounded"
                              classNamePrefix="name-prefix"
                              initialValue={formik?.values?.payment_method}
                              onChangeSelect={(e: any) =>
                                formik.setFieldValue("payment_method", e?.value)
                              }
                              disabled={isShowDetail}
                              colors={COLOR_PAYMENT_METHOD}
                            />
                          </div>
                          {formik.touched.payment_method &&
                          formik.errors.payment_method ? (
                            <div className="text-danger mt-2">
                              {formik.errors.payment_method}
                            </div>
                          ) : null}
                        </div>
                      </Col>
                      <Col lg={3}>
                        <div className="mb-3">
                          <Label htmlFor="origin_price" className="form-label">
                            {t("Origin Price")}{" "}
                            {/* <span className="text-danger">*</span> */}
                          </Label>
                          <Input
                            id="origin_price"
                            name="origin_price"
                            type="number"
                            className="form-control"
                            placeholder={t("Enter origin price")}
                            value={formik?.values?.origin_price}
                            disabled={isShowDetail}
                            onChange={(event: any) =>
                              formik.setFieldValue(
                                "origin_price",
                                event?.target?.value
                              )
                            }
                          />
                          {formik.touched.origin_price &&
                          formik.errors.origin_price ? (
                            <div className="text-danger mt-2">
                              {formik.errors.origin_price}
                            </div>
                          ) : null}
                        </div>
                      </Col>
                      <Col lg={3}>
                        <div className="mb-3">
                          <Label htmlFor="after_price" className="form-label">
                            {t("After Price")}{" "}
                            {/* <span className="text-danger">*</span> */}
                          </Label>
                          <Input
                            id="after_price"
                            name="after_price"
                            type="number"
                            className="form-control"
                            placeholder={t("Enter after price")}
                            value={formik?.values?.after_price}
                            disabled={isShowDetail}
                            onChange={(event: any) =>
                              formik.setFieldValue(
                                "after_price",
                                event?.target?.value
                              )
                            }
                          />
                          {formik.touched.after_price &&
                          formik.errors.after_price ? (
                            <div className="text-danger mt-2">
                              {formik.errors.after_price}
                            </div>
                          ) : null}
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="mb-3">
                          <Label htmlFor="valid_to" className="form-label">
                            {t("Payment status")}{" "}
                            {/* <span className="text-danger">*</span> */}
                          </Label>
                          <div className="w-100">
                            <DropdownStatusNew
                              name="payment_status"
                              dataList={LIST_STATUS_PAYMENT_OPTION || []}
                              placeholder={`${t("Select Status")}...`}
                              className="dropdown-status-rounded"
                              classNamePrefix="name-prefix"
                              initialValue={formik?.values?.payment_status}
                              disabled={isShowDetail}
                              onChangeSelect={(e: any) =>
                                formik.setFieldValue("payment_status", e?.value)
                              }
                              colors={COLOR_STATUS_PAYMENT}
                            />
                          </div>
                          {formik.touched.payment_status &&
                          formik.errors.payment_status ? (
                            <div className="text-danger mt-2">
                              {formik.errors.payment_status}
                            </div>
                          ) : null}
                        </div>
                      </Col>
                    </React.Fragment>
                  ) : (
                    <Col lg={6}>
                      <div className="mb-3">
                        <Label className="form-label d-block">
                          {t("Status")}{" "}
                        </Label>

                        <div
                          className={`text-center rounded-pill badge text-white bg-${
                            LIST_REDEEM_STATUS_OPTION.find(
                              (i) => formik?.values?.status === i?.value
                            )?.value
                          }`}
                          dir="ltr"
                        >
                          {
                            LIST_REDEEM_STATUS_OPTION.find(
                              (i) => formik?.values?.status === i?.value
                            )?.label
                          }
                        </div>
                      </div>
                    </Col>
                  )}
                  <Col lg={12}>
                    <div className="mb-3">
                      <Label htmlFor="valid_to" className="form-label">
                        {t("Validity Option")}{" "}
                      </Label>
                      <div className="d-flex gap-4 align-items-center">
                        <div
                          className="d-flex gap-2 align-items-center cursor-pointer"
                          onClick={() =>
                            formik.setFieldValue("validity_option", false)
                          }
                        >
                          <input
                            type="radio"
                            name="validity_option"
                            checked={!formik?.values?.validity_option}
                            disabled={isShowDetail}
                            onChange={() =>
                              formik.setFieldValue("validity_option", false)
                            }
                          />
                          <p className="m-0">No expiration</p>
                        </div>
                        <div
                          className="d-flex gap-2 align-items-center cursor-pointer"
                          onClick={() =>
                            formik.setFieldValue("validity_option", true)
                          }
                        >
                          <input
                            type="radio"
                            name="validity_option"
                            checked={!!formik?.values?.validity_option}
                            disabled={isShowDetail}
                            onChange={() =>
                              formik.setFieldValue("validity_option", true)
                            }
                          />
                          <p className="m-0">Set a validity period</p>
                        </div>
                      </div>
                    </div>
                  </Col>
                  {!!formik?.values?.validity_option && (
                    <React.Fragment>
                      <Col lg={6}>
                        <div className="mb-3">
                          <Label htmlFor="valid_from" className="form-label">
                            {t("ValidFrom")}{" "}
                            <span className="text-danger">*</span>
                          </Label>
                          <div className="w-100">
                            <DatePicker
                              name={"started_at"}
                              className="form-control"
                              selected={formik?.values?.valid_from}
                              placeholderText={`${t("No data")}`}
                              onChange={(date: any) => {
                                formik.setFieldValue("valid_from", date || "");
                              }}
                              disabled={isShowDetail}
                              locale={"ko"}
                              popperPlacement="auto"
                              wrapperClassName="w-100"
                              dateFormat="yyyy-MM-dd HH:mm:ss"
                              // isClearable={false}
                              showTimeSelect
                            />
                          </div>
                          {formik.touched.valid_from &&
                          formik.errors.valid_from ? (
                            <div className="text-danger mt-2">
                              {formik?.errors?.valid_from as String}
                            </div>
                          ) : null}
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="mb-3">
                          <Label htmlFor="valid_to" className="form-label">
                            {t("ValidTo")}{" "}
                            <span className="text-danger">*</span>
                          </Label>
                          <div className="w-100">
                            <DatePicker
                              name={"started_at"}
                              className="form-control"
                              selected={formik?.values?.valid_to}
                              placeholderText={`${t("No data")}`}
                              disabled={isShowDetail}
                              onChange={(date: any) => {
                                formik.setFieldValue("valid_to", date || "");
                              }}
                              popperPlacement="auto"
                              wrapperClassName="w-100"
                              dateFormat="yyyy-MM-dd HH:mm:ss"
                              // isClearable={false}
                              showTimeSelect
                            />
                          </div>
                          {formik.touched.valid_to && formik.errors.valid_to ? (
                            <div className="text-danger mt-2">
                              {formik?.errors?.valid_to as String}
                            </div>
                          ) : null}
                        </div>
                      </Col>
                    </React.Fragment>
                  )}
                  {isShowDetail ? (
                    <React.Fragment>
                      <Col lg={6}>
                        <div className="mb-3">
                          <Label className="form-label">
                            {t("Created At")}{" "}
                          </Label>

                          <Input
                            type="text"
                            className="form-control"
                            value={formik?.values?.created_at}
                            disabled={isShowDetail}
                          />
                        </div>
                      </Col>

                      <Col lg={6}>
                        <div className="mb-3">
                          <Label className="form-label">
                            {t("Updated At")}{" "}
                          </Label>

                          <Input
                            type="text"
                            className="form-control"
                            value={formik?.values?.updated_at}
                            disabled={isShowDetail}
                          />
                        </div>
                      </Col>
                    </React.Fragment>
                  ) : (
                    <Col lg={6}>
                      <div className="mb-3">
                        <Label htmlFor="language" className="form-label">
                          {t("Subtitle")} <span className="text-danger">*</span>
                        </Label>
                        <DropdownOption
                          name="language"
                          dataList={LIST_LANGUAGE_OPTION}
                          placeholder={`${t("Select Subtitle")}...`}
                          className="dropdown-status-rounded"
                          disabled={isShowDetail}
                          classNamePrefix="name-prefix"
                          initialValue={
                            LIST_LANGUAGE_OPTION?.find(
                              (i: any) => i.value === formik?.values?.language
                            ) || null
                          }
                          onChangeSelect={(e: any) => {
                            if (formik?.values?.language === e?.value) {
                              return;
                            } else {
                              setIsOpenConfirm(e?.value);
                            }
                          }}
                          // isHasOptionAll={true}
                          // optionAll={{ label: t("All Filter"), value: "" }}
                        />
                        {formik.touched.language && formik.errors.language ? (
                          <div className="text-danger mt-2">
                            {formik.errors.language}
                          </div>
                        ) : null}
                      </div>
                    </Col>
                  )}
                  <Col lg={12}>
                    <CourseList
                      formik={formik}
                      // disabled={!!id}
                      disabled={isShowDetail}
                      lang={formik?.values?.language}
                    />
                  </Col>
                  <Col lg={12} className="mt-3 mt-md-2">
                    <div className="mb-3">
                      <Label htmlFor="note" className="form-label">
                        {t("Note")}
                      </Label>
                      <textarea
                        className="form-control"
                        id="note"
                        name="note"
                        value={formik?.values?.note ?? ""}
                        placeholder={`${t("Enter your note")}...`}
                        disabled={isShowDetail}
                        onChange={(event: any) =>
                          formik.setFieldValue(
                            "note",
                            event?.target?.value || ""
                          )
                        }
                        style={{ height: 80 }}
                      />
                      {formik.touched.note && formik.errors.note ? (
                        <div className="text-danger mt-2">
                          {formik.errors.note}
                        </div>
                      ) : null}
                    </div>
                  </Col>
                </Row>

                <Col lg={12}>
                  <div className="hstack gap-2 justify-content-end mt-3">
                    {!isShowDetail && (
                      <button type="submit" className="btn btn-primary fs-14">
                        {isLoading ? (
                          <Spinner size="sm" className="me-2"></Spinner>
                        ) : !!id ? (
                          <i className="ri-login-circle-line align-bottom me-2 "></i>
                        ) : (
                          <i className="ri-add-fill align-bottom me-2"></i>
                        )}
                        {id ? t("Submit Update") : t("Button Create")}
                      </button>
                    )}
                  </div>
                </Col>
              </form>
            </>
          </div>
        </ModalBody>
      </Modal>

      <ModalConfirm
        header={
          "When you select another subtitle, the selected courses will be deleted."
        }
        isOpen={!!isOpenConfirm}
        onClose={onCloseConfirmClick}
        onConfirm={handleAction}
      />
    </React.Fragment>
  );
};

export default AgencyForm;
